import { loadFileAsUint8Array, zstdDecompressString } from "./funcZstd";
import { load as loadYAML } from "js-yaml";
class JobData {
    constructor(parameter) {
        this.parameter = parameter;
    }
    getId() {
        return this.parameter.id_name;
    }
    getIdName() {
        return this.parameter.id_name; // getId()のエイリアス
    }
    getIdNum() {
        return this.parameter.id_num;
    }
    getName() {
        return this.parameter.name;
    }
    getNameJa() {
        return this.parameter.name_ja;
    }
    getNameAlias() {
        return this.parameter.name_alias;
    }
    isRebirthed() {
        return this.parameter.is_rebirthed;
    }
    isDoram() {
        return this.parameter.is_doram;
    }
    getBaseLvMin() {
        return this.parameter.base_lv_min;
    }
    getBaseLvMax() {
        return this.parameter.base_lv_max;
    }
    getJobLvMax() {
        return this.parameter.job_lv_max;
    }
    getLearnedSkills() {
        return Object.keys(this.parameter.learned_skills).map(idx => this.parameter.learned_skills[idx].id);
    }
    getPassiveSkills() {
        return Object.keys(this.parameter.passive_skills).map(idx => this.parameter.passive_skills[idx].id);
    }
    getAttackSkills() {
        return Object.keys(this.parameter.attack_skills).map(idx => this.parameter.attack_skills[idx].id);
    }
    getMigIdNum() {
        return this.parameter._mig_id_num;
    }
    /*
     * 以下は旧式のCMigJobDataを模したメソッド群
     * これらはJobDataParameterのプロパティを参照する形で実装されています。
     * その為、命名規則についても維持しています。
     */
    GetNameKanaArray() {
        let array = [this.parameter.name_ja];
        array = array.concat(this.parameter.name_alias);
        return array;
    }
    GetBaseExpTableId() {
        return 0; //未実装
    }
    GetJobExpTableId() {
        return 0; //未実装
    }
    GetWeightBonus() {
        return this.parameter.weight_correction;
    }
    GetWeaponAspd(wpnType) {
        return this.parameter.weapons_aspd[wpnType];
    }
    GetJobBonus() {
        return [0]; //未実装
    }
    GetHPBase() {
        return this.parameter.hp_basic_values[0];
    }
    GetSPBase() {
        return this.parameter.sp_basic_values[0];
    }
    GetLearnSkillIdArray() {
        return Object.keys(this.parameter.learned_skills).map(id => this.parameter.learned_skills[id].id_num);
    }
    GetPassiveSkillIdArray() {
        return Object.keys(this.parameter.passive_skills).map(id => this.parameter.passive_skills[id].id_num);
    }
    GetAttackSkillIdArray() {
        return Object.keys(this.parameter.attack_skills).map(id => this.parameter.attack_skills[id].id_num);
    }
    IsEquipableEquipFlag(eqpFlag) {
        return this.parameter.allow_equipment_weapons_type.includes(eqpFlag);
    }
}
export class JobMap {
    /** 全ての職業を取得 */
    static getAll() {
        return Object.entries(this.jobMap);
    }
    /** id(string or number) から Job を取得 */
    static getById(key) {
        if (typeof key === 'string') {
            // 文字列の場合はID Nameを検索
            return this.getByIdName(key);
        }
        else if (typeof key === 'number') {
            // 数値の場合はID Numを検索
            return this.getByIdNum(key);
        }
        return undefined;
    }
    /** id_name から Job を取得 */
    static getByIdName(idName) {
        const jobParam = this.jobMap[idName];
        return jobParam !== undefined ? new JobData(jobParam) : undefined;
    }
    /** id_num から Job を取得 */
    static getByIdNum(idNum) {
        for (const job of Object.values(this.jobMap)) {
            if (job.id_num === idNum) {
                return new JobData(job);
            }
        }
        return undefined;
    }
    /** _mig_id_num から Job を取得 */
    static getByMigIdNum(migIdNum) {
        for (const job of Object.values(this.jobMap)) {
            if (job._mig_id_num === migIdNum) {
                return new JobData(job);
            }
        }
        return undefined;
    }
    /** id_name(string or number) から MigIdNum を取得 */
    static getMigIdNumFromById(key) {
        if (typeof key === 'string') {
            // 文字列の場合はID Nameを検索
            return this.getByIdName(key)?.getMigIdNum();
        }
        else if (typeof key === 'number') {
            // 数値の場合は_mig_id_numを検索
            return this.getByIdNum(key)?.getMigIdNum();
        }
        return undefined;
    }
    /** 職業データをロード */
    static async load() {
        const compressed = await loadFileAsUint8Array('../../dist/job.yaml.zst');
        const jobLines = await zstdDecompressString(compressed) || "";
        try {
            // YAMLとしてロード
            this.jobMap = loadYAML(jobLines);
        }
        catch (err) {
            console.error('YAML load error:', err);
        }
    }
    /** ロード完了か確認 **/
    static async isLoaded() {
        return Object.keys(this.jobMap).length > 0;
    }
}
JobMap.jobMap = {};
window.JobMap = JobMap; // グローバルに登録
